<div class="code-editor-buttons">
      <button nz-button nzType="primary" [nzLoading]="buttonLoading" (click)="testCode()" >
            <nz-icon nzType="play-circle" nzTheme="twotone" />
            {{'run'|translateTA}}
      </button>
      <button nz-button nzType="primary" (click)="inputValue=''" >
            <nz-icon nzType="clear" nzTheme="outline" />
            {{'clear'|translateTA}}
      </button>
    
</div>
<nz-divider class="editor-divider"></nz-divider>
<nz-splitter class="code-editor-container" [ngStyle]="{height:height}" >
      <nz-splitter-panel nzDefaultSize="70%" nzMin="40%" [nzCollapsible]="true" >
        <div 
            class="app-ace-editor code-editor-container-code"
            #editor
            
      ></div>
      </nz-splitter-panel>
      <nz-splitter-panel [nzCollapsible]="true"  nzDefaultSize="30%" >
            <div  class="code-editor-container-console" >
                  <!--textarea [(ngModel)]="inputValue" rows="10" cols="50" hidden></textarea-->
                  <pre  #logContainer tabindex="0" wrap="true">{{inputValue}}</pre>
            </div>
      </nz-splitter-panel>
</nz-splitter>
